    @if (customerDetailLoading) {
        <ui-loading-spinner></ui-loading-spinner>
    } @else {
    <div class="page-wrap">
        <div class="headline">
            <div class="title">
                <div class="title-text headline-small-emphasized">{{ customerDetail.ragioneSociale }}</div>

                <button
                    matIconButton
                    type="button"
                    class="notifications-button"
                    aria-label="Apri notifiche cliente"
                    [matBadge]="notificationJson.Count"
                    [matBadgeHidden]="notificationJson.Count === 0"
                    matBadgeColor="warn"
                    matBadgePosition="above after"
                    (click)="onNotificationsButtonClick()"
                    #notificationsOrigin
                >
                    <i class="fa-solid fa-bell"></i>
                </button>
            </div>
            
            <div class="customer-info label-small">Descrizione zona: {{ customerDetail.localita }}</div>
            <div class="customer-info label-small">P.IVA {{ customerDetail.partitaIva }}</div>

            @if (selectedTabIndex === 1 && hasPaymentsToSettle) {
                <button
                    matButton="filled"
                    type="button"
                    class="new-payment-desktop-button"
                    *uiCan="CAPS.incassoCrea"
                    aria-label="Mostra o nascondi nuovo incasso"
                    [attr.aria-expanded]="newPaymentPanelOpen"
                    (click)="toggleNewPaymentPanel()"
                >
                    <i class="fa-regular fa-plus" aria-hidden="true"></i>
                    <span>Incasso</span>
                </button>
            }
        </div>

        <mat-tab-group
            animationDuration="0ms"
            class="tabs"
            [selectedIndex]="selectedTabIndex"
            (selectedIndexChange)="onTabIndexChange($event)"
            mat-align-tabs="start"
        >
            <mat-tab label="Anagrafica">
                <div class="anagrafica-sections">
                    <div class="anagrafica-header">
                        <span class="anagrafica-title title-medium-emphasized">Informazioni anagrafiche</span>
                    </div>

                    <div class="anagrafica-overview">
                        @for (field of anagraficaFields; track field.key) {
                            <div class="anagrafica-overview-field anagrafica-overview-card">
                                <span class="label-small anagrafica-overview-label">{{ field.label }}</span>
                                <span class="label-small-emphasized anagrafica-overview-value">
                                    @if (field.key === 'clienteDal') {
                                        {{ customerDetail.clienteDal ? (customerDetail.clienteDal | date:'dd/MM/yyyy') : '-' }}
                                    } @else {
                                        {{ getAnagraficaValue(field.key) }}
                                    }
                                </span>
                            </div>

                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <div class="contacts">
                        <span class="contacts-title title-medium-emphasized">Contatti</span>

                        <button
                            matIconButton
                            type="button"
                            class="contacts-action contacts-action-mobile"
                            aria-label="Aggiungi contatto"
                            (click)="openAddContactDialog()"
                        >
                            <i class="fa-regular fa-user-plus"></i>
                        </button>

                        <button
                            matButton="filled"
                            type="button"
                            class="contacts-action-filled"
                            aria-label="Aggiungi contatto"
                            (click)="openAddContactDialog()"
                        >
                            <span class="contacts-action-filled-content">
                                <i class="fa-regular fa-user-plus"></i>
                                <span>Aggiungi contatto</span>
                            </span>
                        </button>
                    </div>

                    <div class="contacts-list">
                        <!-- TODO: Introdurre eventualmente ciclo for quando dettaglio sarà completo -->
                        @for (contact of customerContacts; track contact.id) {
                        <div class="contact-element contact-element-mobile">
                            <div class="contact-element-content">
                                <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>
                                <span class="body-small">{{ contact.ruolo || '-' }}</span>
                            </div>

                            <div class="contact-element-actions">
                                <button
                                    matIconButton
                                    type="button"
                                    class="contacts-action"
                                    [attr.aria-label]="'Chiama contatto ' + contact.nominativo"
                                    (click)="openContactPhone(contact)"
                                    [disabled]="!contact.cellulare && !contact.telefono"
                                >
                                    <i class="fa-regular fa-phone"></i>
                                </button>

                                <button
                                    matIconButton
                                    type="button"
                                    class="contacts-action"
                                    [attr.aria-label]="'Altre azioni contatto ' + contact.nominativo"
                                    (click)="setSelectedContact(contact)"
                                    [matMenuTriggerFor]="contactActionsMenu"
                                >
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                            </div>
                        </div>
                            <div class="contact-card">
                                <div class="contact-card-content">
                                    <div class="contact-card-header">
                                        <div class="contact-card-header-layout">
                                            <div class="contact-card-header-content">
                                                <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>

                                                <span class="contact-card-description">
                                                    @if (contact.principale) {
                                                        <i class="fa-solid fa-circle-check"></i>
                                                    }

                                                    <span class="body-small">{{ contact.ruolo || '-' }}</span>
                                                </span>
                                            </div>

                                            <button
                                                matIconButton
                                                type="button"
                                                class="contact-card-action"
                                                [attr.aria-label]="'Altre azioni contatto ' + contact.nominativo"
                                                (click)="setSelectedContact(contact)"
                                                [matMenuTriggerFor]="contactActionsMenu"
                                            >
                                                <i class="fa-solid fa-ellipsis-vertical"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="contact-card-divider"></div>
                                    <div class="contact-card-details">
                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">Telefono</span>
                                            <span class="body-medium-emphasized">{{ contact.telefono || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">Email</span>
                                            <span class="body-medium-emphasized">{{ contact.email || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <mat-menu #contactActionsMenu="matMenu" class="action-menu">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="openSelectedContactEmail()" [disabled]="!selectedContact?.email">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-envelope action-menu-icon"></i>
                                <span class="label-large">Email</span>
                              </span>
                            </button>
                        </div>
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="selectedContact && openEditContactDialog(selectedContact)">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-pencil action-menu-icon"></i>
                                <span class="label-large">Modifica</span>
                              </span>
                            </button>
                        </div>
                        <hr class="action-menu-divider">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="deleteSelectedContact()">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-trash action-menu-icon-delete"></i>
                                <span class="label-large action-menu-label-delete">Elimina</span>
                              </span>
                            </button>
                        </div>           
                    </mat-menu>
                </div>
            </mat-tab>
            <mat-tab label="Partite da saldare">
                @if (!hasPaymentsToSettle) {
                    <div class="payments-empty-state payments-empty-state-mobile">
                        <span class="body-medium">Nessuna partita trovata da saldare</span>
                    </div>
                }

                @if (newPaymentPanelOpen) {
                    <div class="new-payment-mobile-options">
                        <div class="new-payment-mobile-methods">
                            <button
                                matButton="outlined"
                                type="button"
                                [disabled]="selectedPaymentMethod === 'checks'"
                                (click)="openCashBreakdown()"
                            >
                                Contanti
                            </button>
                            <button
                                matButton="outlined"
                                type="button"
                                [disabled]="selectedPaymentMethod === 'cash'"
                                (click)="openChecksBreakdown()"
                            >
                                Assegni
                            </button>
                        </div>

                        <button
                            matIconButton
                            type="button"
                            class="new-payment-mobile-delete"
                            *uiCan="CAPS.incassoElimina"
                            aria-label="Elimina incasso"
                            [disabled]="store.isSaving"
                            (click)="resetNewPayment()"
                        >
                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div class="payment-registration-mobile">
                        <span class="label-medium-emphasized">Registrazione incasso</span>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Acconti/Spese</mat-label>
                            <input matInput [value]="formatAmount(advanceExpensesTotal)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Totale incasso</mat-label>
                            <input matInput [value]="formatAmount(totalIncome)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Residuo disponibile</mat-label>
                            <input matInput [value]="formatAmount(availableResidual)" readonly />
                        </mat-form-field>
                    </div>
                }

                <div class="payments-desktop-content">
                    <span class="payments-desktop-title title-medium-emphasized">Seleziona le partite da saldare</span>

                    @if (newPaymentPanelOpen) {
                        <mat-card class="new-payment-desktop-panel">
                            <mat-card-content class="new-payment-desktop-panel-content">
                                <span class="new-payment-desktop-panel-title title-medium-emphasized">
                                    Registrazione incasso
                                </span>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-method"
                                    [disabled]="selectedPaymentMethod === 'checks'"
                                    (click)="openCashBreakdown()"
                                >
                                    Contanti
                                </button>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-method"
                                    [disabled]="selectedPaymentMethod === 'cash'"
                                    (click)="openChecksBreakdown()"
                                >
                                    Assegni
                                </button>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-account"
                                >
                                    <mat-label>Acconti/Spese</mat-label>
                                    <input matInput [value]="formatAmount(advanceExpensesTotal)" readonly />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-total"
                                >
                                    <mat-label>Totale incasso</mat-label>
                                    <input matInput [value]="formatAmount(totalIncome)" readonly />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-remainder"
                                >
                                    <mat-label>Residuo disponibile</mat-label>
                                    <input matInput [value]="formatAmount(availableResidual)" readonly />
                                </mat-form-field>

                                <button
                                    matButton="filled"
                                    type="button"
                                    class="new-payment-desktop-action new-payment-desktop-confirm"
                                    [disabled]="!store.canConfirm || store.isSaving || !puoConfermareIncasso"
                                    (click)="openReceipt()"
                                >
                                    Conferma ed emetti ricevuta
                                </button>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-action new-payment-desktop-delete"
                                    *uiCan="CAPS.incassoElimina"
                                    [disabled]="store.isSaving"
                                    (click)="resetNewPayment()"
                                >
                                    Elimina incasso
                                </button>
                            </mat-card-content>
                        </mat-card>
                    }

                    @if (hasPaymentsToSettle) {
                        <ui-table-view
                            class="payments-desktop-table"
                            [columnsInfo]="partiteDaSaldareColumns"
                            [data]="partiteDaSaldareTable"
                            (reloadData)="onPaymentAmountChanged()"
                        />
                    } @else {
                        <div class="payments-empty-state payments-empty-state-desktop">
                            <span class="body-medium">Nessuna partita trovata da saldare</span>
                        </div>
                    }
                </div>

                @if (newPaymentPanelOpen) {
                    <div class="payments-processing-list">
                        <span class="label-medium-emphasized">Elenco partite da saldare o in lavorazione</span>

                        @for (payment of partiteDaSaldare; track payment.idDocumento) {
                            <div class="payment-processing-card">
                                <div class="payment-processing-card-top">
                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">ID Doc:</span>
                                            <span class="body-small-emphasized">{{ payment.idDocumento }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">Data doc:</span>
                                            <span class="body-small-emphasized">{{ payment.dataDocumento | date:'dd/MM/yyyy' }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">Scad:</span>
                                            <span class="body-small-emphasized">{{ payment.dataScadenza | date:'dd/MM/yyyy' }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">Descrizione:</span>
                                            <span class="body-small-emphasized">{{ payment.descrizione }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">Totale Fattura:</span>
                                            <span class="body-small-emphasized">
                                                {{ payment.totaleFattura | currency:'EUR':'symbol':'1.2-2' }}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">Importo Residuo:</span>
                                            <span class="body-small-emphasized">
                                                {{ payment.importoResiduo | currency:'EUR':'symbol':'1.2-2' }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <hr class="payment-processing-card-divider" />
                                <div class="payment-processing-card-bottom">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Importo assegnato</mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            [value]="getAssignedAmount(payment.idDocumento)"
                                            (input)="updateAssignedAmount(payment.idDocumento, $event)"
                                        />
                                    </mat-form-field>

                                    <button mat-stroked-button type="button" (click)="saldaPayment(payment)">Saldato</button>
                                </div>
                            </div>
                        }
                    </div>

                    <div class="payments-account-section">
                        <span class="label-medium-emphasized">Acconti/Spese</span>

                        @for (account of accontiSpese; track account.codiceCliente) {
                            <div class="payment-account-card">
                                <div class="payment-account-card-top">
                                    <span class="payment-processing-field">
                                        <span class="body-small">Codice cliente:</span>
                                        <span class="body-small-emphasized">{{ account.codiceCliente }}</span>
                                    </span>

                                    <span class="payment-processing-field">
                                        <span class="body-small">Descrizione:</span>
                                        <span class="body-small-emphasized">{{ account.descrizione }}</span>
                                    </span>
                                </div>

                                <hr class="payment-account-card-divider" />

                                <div class="payment-account-card-bottom">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Importo</mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            [value]="account.importo"
                                            (input)="updateAdvanceExpense(account, $event)"
                                        />
                                    </mat-form-field>
                                </div>
                            </div>
                        }

                        <button
                            matButton="filled"
                            type="button"
                            class="payment-confirm-button title-medium"
                            [disabled]="!store.canConfirm || store.isSaving || !puoConfermareIncasso"
                            (click)="openReceipt()"
                        >
                            Conferma ed emetti ricevuta
                        </button>
                    </div>
                } @else {
                    <div class="payments-mobile-list">
                        @for (payment of partiteDaSaldare; track payment.idDocumento) {
                            <div class="payment-mobile-card">
                                <div class="payment-mobile-data">
                                    <div class="payment-mobile-data-block">
                                        <span class="body-medium-emphasized">{{ payment.idDocumento }}</span>
                                        <span class="body-medium">
                                            Residuo: {{ payment.importoResiduo | currency:'EUR':'symbol':'1.2-2' }}
                                        </span>
                                    </div>

                                    <div class="payment-mobile-data-block">
                                        <span class="body-medium-emphasized">
                                            {{ payment.totaleFattura | currency:'EUR':'symbol':'1.2-2' }}
                                        </span>
                                        <span class="body-medium">
                                            Scad. {{ payment.dataScadenza | date:'dd/MM/yyyy' }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                }

                @if (!newPaymentPanelOpen && hasPaymentsToSettle) {
                    <button
                        matFab
                        extended
                        type="button"
                        class="new-payment-button"
                        *uiCan="CAPS.incassoCrea"
                        aria-label="Apri nuovo incasso"
                        (click)="toggleNewPaymentPanel()"
                    >
                        <i class="fa-regular fa-plus" aria-hidden="true"></i>
                        <span class="new-payment-label title-medium">Incasso</span>
                    </button>
                }
            </mat-tab>
            <mat-tab label="Estratto conto">
                <div class="statement-content">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="statement-filter"
                    >
                        <mat-select
                            [(ngModel)]="statementType"
                            (selectionChange)="loadStatement()"
                            aria-label="Filtra le partite dell'estratto conto"
                        >
                            <mat-option value="all">Visualizza tutte le partite</mat-option>
                            <mat-option value="open">Partite da saldare</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="statement-documents">
                        @for (document of statementDocuments; track document.idDocumento) {
                            <div class="statement-document">
                                <div class="statement-document-summary">
                                    <span class="body-medium-emphasized">{{ document.idDocumento }}</span>
                                    <span class="body-medium-emphasized">
                                        Totale: {{ document.totaleFattura | currency:'EUR':'symbol':'1.2-2' }}
                                    </span>
                                </div>

                                @for (movement of document.pagamenti; track movement.dataPagamento) {
                                    <div
                                        class="statement-movement-card"
                                        [attr.aria-label]="'Movimento del ' + movement.dataPagamento"
                                    >
                                        <div class="statement-movement-column">
                                            <div>
                                                <span class="body-medium">Pagamento: </span>
                                                <span class="body-medium-emphasized">
                                                    {{ movement.importoPagamento | currency:'EUR':'symbol':'1.2-2' }}
                                                </span>
                                            </div>
                                            <div>
                                                <span class="body-medium">Metodo: </span>
                                                <span class="body-medium-emphasized">
                                                    {{ movement.metodoPagamento }}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="statement-movement-column statement-movement-column--end">
                                            <span class="body-medium">
                                                {{ movement.dataPagamento | date:'dd/MM/yyyy' }}
                                            </span>
                                            <div>
                                                <span class="body-medium">Residuo: </span>
                                                <span class="body-medium-emphasized">
                                                    {{ movement.importoResiduo | currency:'EUR':'symbol':'1.2-2' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <ui-table-view
                        class="statement-desktop-table"
                        [columnsInfo]="statementMovementColumns"
                        [data]="statementMovements"
                    />

                    <div class="statement-summary">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Rischio</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.rischio)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Rischio a scadere</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.rischioAScadere)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Scaduti</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.scaduti)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>A scadere</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.aScadere)" readonly />
                        </mat-form-field>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Storico partite">
                <div class="history-search">
                    <span class="history-search-title body-medium-emphasized">
                        Ricerca partite in archivio
                    </span>

                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="history-date-field"
                    >
                        <mat-label>Dal</mat-label>
                        <input
                            matInput
                            [matDatepicker]="historyDateFromPicker"
                            [(ngModel)]="historyDateFrom"
                            placeholder="GG/MM/AAAA"
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="historyDateFromPicker" />
                        <mat-datepicker #historyDateFromPicker />
                    </mat-form-field>

                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="history-date-field"
                    >
                        <mat-label>Al</mat-label>
                        <input
                            matInput
                            [matDatepicker]="historyDateToPicker"
                            [(ngModel)]="historyDateTo"
                            placeholder="GG/MM/AAAA"
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="historyDateToPicker" />
                        <mat-datepicker #historyDateToPicker />
                    </mat-form-field>

                    <button
                        matButton="filled"
                        type="button"
                        class="history-search-button"
                        (click)="cercaStorico()"
                    >
                        Cerca
                    </button>

                    <div class="history-results">
                        @for (payment of historyPayments; track payment.idDocumento) {
                            <div class="history-card">
                                <div class="history-card-column">
                                    <span class="body-medium-emphasized">
                                        {{ payment.idDocumento }}
                                    </span>
                                    <span class="body-medium">
                                        Chiusa il {{ payment.dataChiusura | date:'dd/MM/yyyy' }}
                                    </span>
                                </div>

                                <div class="history-card-column history-card-column--end">
                                    <span class="body-medium-emphasized">
                                        {{ payment.totaleFattura | currency:'EUR':'symbol':'1.2-2' }}
                                    </span>
                                    <span class="body-medium">
                                        {{ payment.situazione }}
                                    </span>
                                </div>
                            </div>
                        } @empty {
                            <div class="payments-empty-state">
                                <span class="body-medium">Nessuna partita chiusa trovata</span>
                            </div>
                        }
                    </div>

                    <ui-table-view
                        class="history-desktop-table"
                        [columnsInfo]="historyPaymentColumns"
                        [data]="historyPaymentsTable"
                    />
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    }

    <ng-template #notificationsPanel>
        <div class="notifications-panel" role="dialog" aria-label="Notifiche cliente">
            <div class="notifications-panel-header">
                <span class="title-large-emphasized">Notifiche</span>

                <button
                    matIconButton
                    type="button"
                    aria-label="Chiudi notifiche"
                    (click)="closeNotificationsPanel()"
                >
                    <i class="fa-regular fa-xmark"></i>
                </button>
            </div>

            <div class="notifications-panel-content">
                <div class="notifications-list">
                    @for (item of notificationJson.Notifications; track item.Id) {
                        <div class="notification-card" [class]="getNotificationCardClass(item.Severity)">
                            <div class="notification-card-header">
                                <div class="notification-card-header-container">
                                    <div class="notification-card-header-icon-container">
                                        <div class="notification-card-icon">
                                            <i [class]="getNotificationIconClass(item.Severity) + ' ' + getNotificationIconColorClass(item.Severity)"></i>
                                        </div>
                                    </div>

                                    <div class="notification-card-header-content">
                                        <span class="body-medium-emphasized notification-card-title" [class]="getNotificationIconColorClass(item.Severity)">{{ item.Title }}</span>
                                        <span class="body-medium notification-card-description">{{ item.Description || '-' }}</span>
                                    </div>
                                </div>

                                <div class="notification-card-header-close">
                                    <button matIconButton type="button" (click)="$event.stopPropagation()">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="notification-card-footer">
                                @if (item.ToAction) {
                                    <button matButton type="button" class="notification-card-action">
                                        <span class="notification-card-action-content">
                                            <i class="fa-regular fa-up-right-from-square"></i>
                                            <span>{{ getNotificationActionLabel(item) }}</span>
                                        </span>
                                    </button>
                                }
                            </div>
                        </div>
                    }

                    @if (!notificationJson.Notifications?.length) {
                        <div class="notifications-empty-state">
                            <span class="body-large-emphasized">Nessuna notifica</span>
                            <span class="body-medium">Quando arriveranno nuove notifiche, le troverai qui.</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </ng-template>

